"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackAction = void 0;
const mfe_common_common_utils_lib_1 = require("mfe-common-common-utils-lib");
function trackAction(actionName, data) {
    const actionId = mfe_common_common_utils_lib_1.DynatraceService.enterAction({ actionName });
    if (data) {
        mfe_common_common_utils_lib_1.DynatraceService.addActionProperties(actionId, data);
    }
    const param = { actionId };
    mfe_common_common_utils_lib_1.DynatraceService.leaveAction(param);
}
exports.trackAction = trackAction;
